export const PLAN_CARD_DETAIL_HEIGHT = 305;
export const NEW_BUSINESS_COST_ID = 'newBusinessCost';
export const NOT_BILLABLE_CARD_WIDTH = 400;
